export default {
  reportBuilder: 'Tvorba reportov',
  subheadline: 'Tieto nastavenia definujú globálny vzhľad PDF súborov generovaných systémom Qmulus.',
};
